import { BrokerId, FrontendLoadLocation } from '@trucksmarter/shared';
import { formatAppointmentTimestamp } from '@trucksmarter/shared_frontend';
import { formatCityAndState } from '~/utils/location';
import DallasText from '~/app/_ui/Dallas/Text/DallasText';

import styles from './LoadTableStopList.module.scss';

interface Props {
  stops: FrontendLoadLocation[];
  brokerId: BrokerId;
}

export default function LoadTableStopList({ stops, brokerId }: Props) {
  return (
    <ul className={styles.root}>
      {stops.map((stop, i) => {
        const {
          address: { city, state },
        } = stop;
        const formattedAppointment = formatAppointmentTimestamp(stop, brokerId);

        return (
          <div key={i} className={styles.item}>
            <DallasText
              className={styles.itemHeader}
              variant="captionL"
              as="div"
            >
              {formatCityAndState(city, state)}
            </DallasText>

            <div className={styles.itemContent}>
              <DallasText variant="captionL">{formattedAppointment}</DallasText>
            </div>
          </div>
        );
      })}
    </ul>
  );
}
